import React from 'react';
import logo from '../../assets/img/icons/LogoGuardianNova-h.png';
import './footer.css';
const Footer = () => {
  return (
    <footer className="grd-footer no-print">
      <div className="footer-content">
        <img src={logo}/>
        <div>
          <span>
            &copy;
            {new Date().getFullYear()}
            {' '}
            <a target='_blank' href="https://www.guardianrh.com.br/" rel="noreferrer">Guardian</a> | Desenvolvido por profissionais de RH para profissionais de RH
          </span>
        </div>
      </div>
    </footer>
  );
};
 
export default Footer;